<template>
  <div class="intellidata-device-iorecord">
    <div class>
      <!-- 顶部停车场选项 -->
      <div
        style="padding: 20px 20px 0 20px; max-height: 100vh; overflow: hidden;"
      >
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="共享停车场" style="width: 350px;">
            <el-select
              v-model="queryForm.sharedParking"
              placeholder="请选择共享停车场"
              style="width: 250px;"
              @change="handleSharedParkingChange"
              clearable
            >
              <el-option
                v-for="item in sharedParkingOps"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="共享停车位">
            <el-select
              v-model="queryForm.parkingSpace"
              placeholder="请选择共享停车位"
              @change="handleParkingSpaceChange"
              clearable
            >
              <el-option
                v-for="item in currentParkingSpaceOps"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单编号">
            <el-input
              v-model="commonQuery.orderNum"
              placeholder="请输入预约订单号"
              clearable
              @clear="commonQuery.orderNum = undefined"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchList"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <!--左侧列表展示进出场记录-->
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-loading="loading"
        >
          <el-table-column
            show-overflow-tooltip
            label="订单编号"
            prop="orderNum"
            width="200"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车位号"
            prop="uniqueId"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车场名称"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="实付金额"
            prop="actualAmount"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.actualAmount, "-", "", "元") }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="分账金额"
            prop="profitAmount"
          >
            <template slot-scope="scope">
              {{ utils.getOrDefault(scope.row.profitAmount, "-", "", "元") }}
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="是否是订单超时分账"
            prop="overtimeText"
          >
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="分账类型"
            prop="profitTypeText"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="分账规则值"
            prop="typeValue"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="超时分账值"
            prop="overtimeProfit"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="分账方类型"
            prop="payeeTypeText"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="记录状态"
            prop="statusText"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="分账时间"
            prop="createTime"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>

    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { splitBillRecord, shareParkCascade } from "@/api/url";
import * as utils from "@/utils/utils";
import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

export default {
  data() {
    return {
      queryForm: {
        sharedParking: undefined,
        parkingSpace: undefined,
      },
      commonQuery: {
        type: undefined,
        id: undefined,
        orderNum: undefined,
      },
      sharedParkingOps: [],
      currentParkingSpaceOps: [],
      loading: false,
      parks: [],
      photoDialogVisible: false,
      photoY: false,
      photoN: false,
      treeData: {
        parkingId: "",
      },
      observer: null,
      recordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        elementHeight: "0",
      },
      observer1: null,
      innerRecordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        innerHeight: "0",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      moduleName: "",
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        parkingId: "",
      },
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},

      defaultProps: {
        children: "children",
        label: "label",
      },
      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: "",
      utils,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },
    handleSharedParkingChange(val) {
      this.queryForm.parkingSpace = undefined;
      const space = this.sharedParkingOps.find((f) => f.value === val);
      if (space) {
        this.currentParkingSpaceOps = space.children;
      }

      this.commonQuery.type = 1;
      this.commonQuery.id = val;
    },
    handleParkingSpaceChange(val) {
      this.commonQuery.type = 2;
      this.commonQuery.id = val;
    },
    tableList: function(curPage) {
      if (this.commonQuery.id === undefined) {
        this.$message({ type: "error", message: "请先选择停车场或停车位" });
        return;
      }
      this.loading = true;
      var _this = this;
      this.$get(splitBillRecord(), {
        limit: this.search.pageSize,
        page: curPage,
        ...this.commonQuery,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页

        var rows = data.data.rows;

        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows.map((record) => {
          return record;
        });
        this.loading = false;
      });
    },
    searchList: function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
  },
  mounted: async function() {
    const data = await this.$get(shareParkCascade());
    if (data.status == 200) {
      this.sharedParkingOps = data.data;
    }
  },
};
</script>

<style scoped>
.boxbgcolor {
  width: 100%;
  display: flex;
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
            line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.intellidata-device-iorecord img {
  display: inline-block;
  margin-right: 2px;
}
</style>
